import {type IAsset} from '@netx/core-asset-next/schema';
import {getPreference} from '@netx/core-user-next/utils/getPreference';

export const enabled = () => {
	return getPreference('metadata.smartLabels.enabled', true);
};

export const supportsAsset = (assetData: IAsset) => {
	const {fileFormatFamily} = assetData;
	return (
		fileFormatFamily.includes('image') ||
		fileFormatFamily.includes('raw') ||
		fileFormatFamily.includes('cameraRaw')
	);
};
